import { ModulesMap } from '@/config/data/modulesMaps'

import landDocumentsDtConfig from './landDocumentsDtConfig'
import equipmentRegistrationsDtConfig from './equipmentRegistrationsDtConfig'
import equipmentFactplacesDtConfig from './equipmentFactplacesDtConfig'
import incidentCommentsDtConfig from './incidentsComentsDtConfig'
import incidentsDtConfig from './incidentsDtConfig'
import incidentsMyWorksToAdministrateIncidentsDtConfig from './incidentsMyWorksToAdministrateIncidentsDtConfig'
import regulationsStagesPlanWorksQualitiControlsDtConfig from './regulationsStagesPlanWorksQualitiControlsDtConfig'
import regulationsStagesPlanWorksServicePaymentsDtConfig from './regulationsStagesPlanWorksServicePaymentsDtConfig'
import regulationsStagesPlanWorksStaffPaymentsDtConfig from './regulationsStagesPlanWorksStaffPaymentsDtConfig '
import regulationsStagesPlanWorksStaffGroupsDtConfig from './regulationsStagesPlanWorksStaffGroupsDtConfig'
import regulationsStagesPlanWorksProductsDtConfig from './regulationsStagesPlanWorksProductsDtConfig'
import regulationsStagesPlanWorksMaterialsDtConfig from './regulationsStagesPlanWorksMaterialsDtConfig'

import trips from './tripsDtConfig'
import positionDevices from './positionDevicesDtConfig'
import worksServicePaymentRateNormsDtConfig from './worksServicePaymentRateNormsDtConfig'
import worksMaterialProductionRateNormsDtConfig from './worksMaterialProductionRateNormsDtConfig'
import staffAndMachineryCardsDtConfig from './staffAndMachineryCardsDtConfig'
import cacheDtConfig from './cacheDtConfig'
import userDtConfig from './userDtConfig'
import companyDtConfig from './companyDtConfig'
import companyFuelSettingsDtConfig from './companyFuelSettingsDtConfig'
import authDtConfig from './authDtConfig'
import presetsDtConfig from './presetsDtConfig'
import machinesDtConfig from './machinesDtConfig'
import equipmentDtConfig from './equipmentDtConfig'
import infrastructureTypesDtConfig from './infrastructureTypesDtConfig'
import partnersDtConfig from './partnersDtConfig'
import aggregateCardsDtConfig from './aggregateCardsDtConfig'
import infrastructureTagsDtConfig from './infrastructureTagsDtConfig'
import gpsSourcesDtConfig from './gpsSourcesDtConfig'
import identityMountsDtConfig from './identityMountsDtConfig'
import identityCardsDtConfig from './identityCardsDtConfig'
import machineBrigadeDtConfig from './machineBrigadeDtConfig'
import machinePhotosDtConfig from './machinePhotosDtConfig'
import machineTransfersDtConfig from './machineTransfersDtConfig'
import fuelDtConfig from './fuelDtConfig'
import fuelStationsDtConfig from './fuelStationsDtConfig'
import fuelStationEventsDtConfig from './fuelStationEventsDtConfig'
import fuelStationRawEventsDtConfig from './fuelStationRawEventsDtConfig'
import fuelStationGunsDtConfig from './fuelStationGunsDtConfig'
import worksMaterialConsumptionRateNormsDtConfig from './worksMaterialConsumptionRateNormsDtConfig'
import worksProductivityNormsDtConfig from './worksProductivityNormsDtConfig'
import worksQualityNormsDtConfig from './worksQualityNormsDtConfig'
import regulationsApplicationAreaDtConfig from './regulationsApplicationAreaDtConfig'
import worksStaffPaymentRatesNormsDtConfig from './worksStaffPaymentRatesNormsDtConfig'
import cropsDtConfig from './cropsDtConfig'
import positionsMachinesDtConfig from './positionsMachinesDtConfig'
import eventsDtConfig from './eventsDtConfig'
import infrastructurePhotosDtConfig from './infrastructurePhotosDtConfig'
import equipmentPhotosDtConfig from './equipmentPhotosDtConfig'
import regulationsMetricsDtConfig from './regulationsMetricsDtConfig'
import regulationsStagesDtConfig from './regulationsStagesDtConfig'
import regulationsTargetProductsDtConfig from './regulationsTargetProductsDtConfig'
import regulationsStagesPlanWorksDtConfig from './regulationsStagesPlanWorksDtConfig'
import mapsDtConfig from './mapsDtConfig'
import businessProcessesDtConfig from './businessProcessesDtConfig'
import regulationBaseFinanceAttributionDtConfig from './regulationBaseFinanceAttributionDtConfig'
import notificationsDtConfig from './notificationsDtConfig'
import regulationPlanWorkFinanceAttributionDtConfig from './regulationPlanWorkFinanceAttributionDtConfig'
import reportFinanceByCategoriesDtConfig from './reportFinanceByCategoriesDtConfig'
import reportFinanceByDestinationDtConfig from './reportFinanceByDestinationDtConfig'
import reportFinanceByWorkTypesDtConfig from './reportFinanceByWorkTypesDtConfig'
import reportFinanceEfficiencyDtConfig from './reportFinanceEfficiencyDtConfig'
import reportFinanceProductsDtConfig from './reportFinanceProductsDtConfig'
import reportStagesProgressDtConfig from './reportStagesProgressDtConfig'
import reportStagesProgressWithWorksDtConfig from './reportStagesProgressWithWorksDtConfig'
import reportsDtConfig from './reportsDtConfig'
import reportsDoneWorksCostsDtConfig from './reportsDoneWorksCostsDtConfig'
import reportsQualityControlsDtConfig from './reportsQualityControlsDtConfig'
import reportsDoneWorksDtConfig from './reportsDoneWorksDtConfig'
import reportsServicePaymentsDtConfig from './reportsServicePaymentsDtConfig'
import reportsStaffPaymentsDtConfig from './reportsStaffPaymentsDtConfig'
import reportsFinanceByMaterialsCategoriesDtConfig from './reportsFinanceByMaterialsCategoriesDtConfig'
import reportsFinanceByServicesDtConfig from './reportsFinanceByServicesDtConfig'
import reportsFinanceByWorkCategoriesDtConfig from './reportsFinanceByWorkCategoriesDtConfig'
import reportsFinanceByRolesDtConfig from './reportsFinanceByRolesDtConfig'
import doneWorksBrigadeDtConfig from './doneWorksBrigadeDtConfig'
import doneWorksCalculationVolumeMetricsDtConfig from './doneWorksCalculationVolumeMetricsDtConfig'
import doneWorksDocumentsDtConfig from './doneWorksDocumentsDtConfig'
import doneWorksFinanceAttributionDtConfig from './doneWorksFinanceAttributionDtConfig'
import doneWorksLinksDtConfig from './doneWorksLinksDtConfig'
import doneWorksMeasuresDtConfig from './doneWorksMeasuresDtConfig'
import doneWorksPhotosDtConfig from './doneWorksPhotosDtConfig'
import doneWorksDtConfig from './doneWorksDtConfig'
import regulationsStagesPlanWorksRecomendedMachinesDtConfig from './regulationsStagesPlanWorksRecomendedMachinesDtConfig'
import regulationsStagesPlanWorksRecomendedEquipmentDtConfig from './regulationsStagesPlanWorksRecomendedEquipmentDtConfig'
import regulationsStagesPlanWorksRecomendedCounterpartiesDtConfig from './regulationsStagesPlanWorksRecomendedCounterpartiesDtConfig'
import regulationsStagesPlanWorksRecomendedStaffDtConfig from './regulationsStagesPlanWorksRecomendedStaffDtConfig'
import regulationsFinanceProductivityDtConfig from './regulationsFinanceProductivityDtConfig'
import reportsReportingDtConfig from './reportsReportingDtConfig'

import regulationStageFinanceAttributionDtConfig from './regulationStageFinanceAttributionDtConfig'
import doneWorksManufacturedMaterialsDtConfig from './doneWorksManufacturedMaterialsDtConfig'
import doneWorksOperationalMaterialsDtConfig from './doneWorksOperationalMaterialsDtConfig'
import doneWorksServicesDtConfig from './doneWorksServicesDtConfig'
import doneWorksCalculationMaterialsMetricsDtConfig from './doneWorksCalculationMaterialsMetricsDtConfig'
import doneWorksInProgressFieldWorksDtConfig from './doneWorksInProgressFieldWorksDtConfig'
import businessProcessesActivePlanWorksDtConfig from './businessProcessesActivePlanWorksDtConfig'
import rulesBreakingDtConfig from './rulesBreakingDtConfig'
import doneWorksControlMetricDtConfig from './doneWorksControlMetricDtConfig'
import workOrdersDtConfig from './workOrdersDtConfig'
import workOrdersMaterialsDtConfig from './workOrdersMaterialsDtConfig'
import workOrdersProductsDtConfig from './workOrdersProductsDtConfig'
import doneWorksDoneFieldWorksDtConfig from './doneWorksDoneFieldWorksDtConfig'
import weighingCombinerTicketsDtConfig from './weighingCombinerTicketsDtConfig'
import doneWorksMyWorksToAdministrateDtConfig from './doneWorksMyWorksToAdministrateDtConfig'
import doneWorksMyWorksToControlDtConfig from './doneWorksMyWorksToControlDtConfig'
import doneWorksMyWorksToDoDtConfig from './doneWorksMyWorksToDoDtConfig'
import orderGeneratorsFieldsWorksDtConfig from './orderGeneratorsFieldsWorksDtConfig'
import orderGeneratorsFieldsWorksPlanWorksDtConfig from './orderGeneratorsFieldsWorksPlanWorksDtConfig'
import orderGeneratorsFieldsWorksExecutorsDtConfig from './orderGeneratorsFieldsWorksExecutorsDtConfig'
import orderGeneratorsFieldsWorksExecutorsBrigadesDtConfig from './orderGeneratorsFieldsWorksExecutorsBrigadesDtConfig'
import orderGeneratorsFieldsWorksMaterialsDtConfig from './orderGeneratorsFieldsWorksMaterialsDtConfig'
import orderGeneratorsFieldsWorksProductsDtConfig from './orderGeneratorsFieldsWorksProductsDtConfig'
import orderGeneratorsFieldsWorksQualityControlsDtConfig from './orderGeneratorsFieldsWorksQualityControlsDtConfig'
import orderGeneratorsFieldsWorksStaffPaymentsDtConfig from './orderGeneratorsFieldsWorksStaffPaymentsDtConfig'
import orderGeneratorsFieldsWorksServicesDtConfig from './orderGeneratorsFieldsWorksServicesDtConfig'
import logisticRoutesDtConfig from './logisticRoutesDtConfig'
import logisticRoutesGeoZones from './logisticRoutesGeoZonesDtConfig'
import reportDeviceMountsDtConfig from './reportDeviceMountsDtConfig'
import doneWorksAllFieldWorksDtConfig from './doneWorksAllFieldWorksDtConfig'
import doneWorksAllLogisticWorksDtConfig from './doneWorksAllLogisticWorksDtConfig'
import doneWorksAllHandMadeWorksDtConfig from './doneWorksAllHandMadeWorksDtConfig'
import regulationsAllPlanWorksDtConfig from './regulationsAllPlanWorksDtConfig'
import cargosDtConfig from './cargosDtConfig'
import cargoItemsDtConfig from './cargoItemsDtConfig'
import cargoTagsDtConfig from './cargoTagsDtConfig'
import apiUsagesDtConfig from './apiUsagesDtConfig'
import landsDtConfig from './landsDtConfig'
import equipmentDocumentsDtConfig from './equipmentDocumentsDtConfig'
import equipmentPledgesDtConfig from './equipmentPledgesDtConfig'
import landsCadastralCasesDtConfig from './landsCadastralCasesDtConfig'
import customGeoZonesCategoriesDtConfig from './customGeoZonesCategoriesDtConfig'
import customGeoZonesDtConfig from './customGeoZonesDtConfig'
import regulationsStaffRolesInfoDtConfig from './regulationsStaffRolesInfoDtConfig'
import businessProcessBaseExecutorsDtConfig from './businessProcessBaseExecutorsDtConfig'

export default {
	[ModulesMap.LAND_DOCUMENTS]: landDocumentsDtConfig,
	[ModulesMap.EQUIPMENT_REGISTRATIONS]: equipmentRegistrationsDtConfig,
	[ModulesMap.EQUIPMENT_FACTPLACES]: equipmentFactplacesDtConfig,
	[ModulesMap.INCIDENT_COMMENTS]: incidentCommentsDtConfig,
	[ModulesMap.INCIDENTS]: incidentsDtConfig,
	[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS]: incidentsMyWorksToAdministrateIncidentsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]:
		regulationsStagesPlanWorksQualitiControlsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]:
		regulationsStagesPlanWorksServicePaymentsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]:
		regulationsStagesPlanWorksStaffPaymentsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]:
		regulationsStagesPlanWorksStaffGroupsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]: regulationsStagesPlanWorksProductsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]: regulationsStagesPlanWorksMaterialsDtConfig,
	[ModulesMap.TRIPS]: trips,
	[ModulesMap.POSITION_DEVICES]: positionDevices,
	[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]: worksServicePaymentRateNormsDtConfig,
	[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: worksMaterialProductionRateNormsDtConfig,
	[ModulesMap.STAFF_AND_MACHINERY_CARDS]: staffAndMachineryCardsDtConfig,
	[ModulesMap.CACHE]: cacheDtConfig,
	[ModulesMap.USER]: userDtConfig,
	[ModulesMap.COMPANY]: companyDtConfig,
	[ModulesMap.COMPANY_FUEL_SETTINGS]: companyFuelSettingsDtConfig,
	[ModulesMap.AUTH]: authDtConfig,
	[ModulesMap.PRESETS]: presetsDtConfig,
	[ModulesMap.MACHINES]: machinesDtConfig,
	[ModulesMap.EQUIPMENT]: equipmentDtConfig,
	[ModulesMap.INFRASTRUCTURE_TYPES]: infrastructureTypesDtConfig,
	[ModulesMap.PARTNERS]: partnersDtConfig,
	[ModulesMap.AGGREGATE_CARDS]: aggregateCardsDtConfig,
	[ModulesMap.INFRASTRUCTURE_TAGS]: infrastructureTagsDtConfig,
	[ModulesMap.GPS_SOURCES]: gpsSourcesDtConfig,
	[ModulesMap.IDENTITY_CARDS]: identityCardsDtConfig,
	[ModulesMap.IDENTITY_MOUNTS]: identityMountsDtConfig,
	[ModulesMap.MACHINE_BRIGADE]: machineBrigadeDtConfig,
	[ModulesMap.MACHINE_PHOTOS]: machinePhotosDtConfig,
	[ModulesMap.MACHINE_TRANSFERS]: machineTransfersDtConfig,
	[ModulesMap.FUEL]: fuelDtConfig,
	[ModulesMap.FUEL_STATIONS]: fuelStationsDtConfig,
	[ModulesMap.FUEL_STATION_EVENTS]: fuelStationEventsDtConfig,
	[ModulesMap.FUEL_STATION_RAW_EVENTS]: fuelStationRawEventsDtConfig,
	[ModulesMap.FUEL_STATION_GUNS]: fuelStationGunsDtConfig,
	[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: worksMaterialConsumptionRateNormsDtConfig,
	[ModulesMap.WORKS_PRODUCTIVITY_NORMS]: worksProductivityNormsDtConfig,
	[ModulesMap.WORKS_QUALITY_NORMS]: worksQualityNormsDtConfig,
	[ModulesMap.REGULATIONS_APPLICATION_AREA]: regulationsApplicationAreaDtConfig,
	[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS]: worksStaffPaymentRatesNormsDtConfig,
	[ModulesMap.CROPS]: cropsDtConfig,
	[ModulesMap.POSITIONS_MACHINES]: positionsMachinesDtConfig,
	[ModulesMap.EVENTS]: eventsDtConfig,
	[ModulesMap.INFRASTRUCTURE_PHOTOS]: infrastructurePhotosDtConfig,
	[ModulesMap.EQUIPMENT_PHOTOS]: equipmentPhotosDtConfig,
	[ModulesMap.REGULATIONS_METRICS]: regulationsMetricsDtConfig,
	[ModulesMap.REGULATIONS_STAGES]: regulationsStagesDtConfig,
	[ModulesMap.REGULATIONS_TARGET_PRODUCTS]: regulationsTargetProductsDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]: regulationsStagesPlanWorksDtConfig,
	[ModulesMap.MAPS]: mapsDtConfig,

	[ModulesMap.BUSINESS_PROCESSES]: businessProcessesDtConfig,
	[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]: regulationBaseFinanceAttributionDtConfig,
	[ModulesMap.NOTIFICATIONS]: notificationsDtConfig,
	[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]:
		regulationPlanWorkFinanceAttributionDtConfig,
	[ModulesMap.REPORTS]: reportsDtConfig,
	[ModulesMap.REPORTS_DONE_WORKS_COSTS]: reportsDoneWorksCostsDtConfig,
	[ModulesMap.REPORTS_QUALITY_CONTROLS]: reportsQualityControlsDtConfig,
	[ModulesMap.REPORTS_DONE_WORKS]: reportsDoneWorksDtConfig,
	[ModulesMap.REPORTS_SERVICE_PAYMENTS]: reportsServicePaymentsDtConfig,
	[ModulesMap.REPORTS_STAFF_PAYMENTS]: reportsStaffPaymentsDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES]: reportFinanceByCategoriesDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_DESTINATION]: reportFinanceByDestinationDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE]: reportFinanceByWorkTypesDtConfig,
	[ModulesMap.REPORTS_FINANCE_EFFICIENCY]: reportFinanceEfficiencyDtConfig,
	[ModulesMap.REPORTS_FINANCE_PRODUCTS]: reportFinanceProductsDtConfig,
	[ModulesMap.REPORTS_STAGES_PROGRESS]: reportStagesProgressDtConfig,
	[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS]: reportStagesProgressWithWorksDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES]: reportsFinanceByMaterialsCategoriesDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_SERVICES]: reportsFinanceByServicesDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES]: reportsFinanceByWorkCategoriesDtConfig,
	[ModulesMap.REPORTS_FINANCE_BY_ROLES]: reportsFinanceByRolesDtConfig,
	[ModulesMap.DONE_WORKS_BRIGADE]: doneWorksBrigadeDtConfig,
	[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS]: doneWorksCalculationVolumeMetricsDtConfig,
	[ModulesMap.DONE_WORKS_DOCUMENTS]: doneWorksDocumentsDtConfig,
	[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION]: doneWorksFinanceAttributionDtConfig,
	[ModulesMap.DONE_WORKS_LINKS]: doneWorksLinksDtConfig,
	[ModulesMap.DONE_WORKS_MEASURES]: doneWorksMeasuresDtConfig,
	[ModulesMap.DONE_WORKS_PHOTOS]: doneWorksPhotosDtConfig,
	[ModulesMap.DONE_WORKS]: doneWorksDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]: regulationsStagesPlanWorksRecomendedMachinesDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]: regulationsStagesPlanWorksRecomendedEquipmentDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]: regulationsStagesPlanWorksRecomendedCounterpartiesDtConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]: regulationsStagesPlanWorksRecomendedStaffDtConfig,
	[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY]: regulationsFinanceProductivityDtConfig,
	[ModulesMap.REPORTS_REPORTING]: reportsReportingDtConfig,
	[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]: regulationStageFinanceAttributionDtConfig,
	[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS]: doneWorksManufacturedMaterialsDtConfig,
	[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS]: doneWorksOperationalMaterialsDtConfig,
	[ModulesMap.DONE_WORKS_SERVICES]: doneWorksServicesDtConfig,
	[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS]: doneWorksCalculationMaterialsMetricsDtConfig,
	[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS]: doneWorksInProgressFieldWorksDtConfig,
	[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]: businessProcessesActivePlanWorksDtConfig,
	[ModulesMap.RULES_BREAKING]: rulesBreakingDtConfig,
	[ModulesMap.DONE_WORKS_CONTROL_METRICS]: doneWorksControlMetricDtConfig,
	[ModulesMap.WORK_ORDERS]: workOrdersDtConfig,
	[ModulesMap.WORK_ORDERS_MATERIALS]: workOrdersMaterialsDtConfig,
	[ModulesMap.WORK_ORDERS_PRODUCTS]: workOrdersProductsDtConfig,
	[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS]: doneWorksDoneFieldWorksDtConfig,
	[ModulesMap.WEIGHING_COMBINER_TICKETS]: weighingCombinerTicketsDtConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE]: doneWorksMyWorksToAdministrateDtConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL]: doneWorksMyWorksToControlDtConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO]: doneWorksMyWorksToDoDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS]: orderGeneratorsFieldsWorksDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS]: orderGeneratorsFieldsWorksPlanWorksDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS]: orderGeneratorsFieldsWorksExecutorsDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES]: orderGeneratorsFieldsWorksExecutorsBrigadesDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS]: orderGeneratorsFieldsWorksMaterialsDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS]: orderGeneratorsFieldsWorksProductsDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS]: orderGeneratorsFieldsWorksQualityControlsDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS]: orderGeneratorsFieldsWorksStaffPaymentsDtConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES]: orderGeneratorsFieldsWorksServicesDtConfig,
	[ModulesMap.LOGISTIC_ROUTES]: logisticRoutesDtConfig,
	[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES]: logisticRoutesGeoZones,
	[ModulesMap.REPORT_DEVICE_MOUNTS]: reportDeviceMountsDtConfig,
	[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS]: doneWorksAllFieldWorksDtConfig,
	[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS]: doneWorksAllLogisticWorksDtConfig,
	[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS]: doneWorksAllHandMadeWorksDtConfig,
	[ModulesMap.REGULATIONS_ALL_PLAN_WORKS]: regulationsAllPlanWorksDtConfig,
	[ModulesMap.CARGOS]: cargosDtConfig,
	[ModulesMap.CARGO_ITEMS]: cargoItemsDtConfig,
	[ModulesMap.CARGO_TAGS]: cargoTagsDtConfig,
	[ModulesMap.API_USAGES]: apiUsagesDtConfig,
	[ModulesMap.LANDS]: landsDtConfig,
	[ModulesMap.EQUIPMENT_DOCUMENTS]: equipmentDocumentsDtConfig,
	[ModulesMap.EQUIPMENT_PLEDGES]: equipmentPledgesDtConfig,
	[ModulesMap.LANDS_CADASTRAL_CASES]: landsCadastralCasesDtConfig,
	[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES]: customGeoZonesCategoriesDtConfig,
	[ModulesMap.CUSTOM_GEO_ZONES]: customGeoZonesDtConfig,
	[ModulesMap.REGULATIONS_STAFF_ROLES_INFO]: regulationsStaffRolesInfoDtConfig,
	[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS]: businessProcessBaseExecutorsDtConfig,
}
